<ng-template #rt let-r="result" let-t="term">
  {{ r.name }}
</ng-template>
<ng-template #railairtemp let-r="result" let-t="term">
  {{ r.destination }}
</ng-template>
<ng-template #cityRt let-r="result" let-t="term">
  <span> {{ r.name }} ({{ r.countryCode }})</span>
</ng-template>
<ng-template #cityRt1 let-r="result" let-t="term">
  <span [innerHTML]="r.name + ' (' + r.countryCode + ')'"></span>
</ng-template>
@if (
  {
    results: searchService.searches[ServiceType.Car].results | async,
    isvalid: searchService.searches[ServiceType.Car].isValid | async,
    messages: searchService.searches[ServiceType.Car].messages | async,
    conversionRates: conversionRates$ | async
  };
  as data
) {
  <div>
    <h2 class="visuallyhidden" i18n="@@cars_searchCriteria">Search Criteria</h2>
    <a href="javascript:void(0)" (click)="skipToResultContent()" class="sr-only sr-only-focusable"
      >Skip to Result Content</a
    >
    <app-invoked-user></app-invoked-user>
  </div>
  <!-- search -->
  @if (!searchService.search_loading) {
    <div class="car_search_content background-container-background flex-column-container">
      <app-search-toggle [serviceType]="ServiceType.Car">
        <a
          href="javascript:void(0)"
          (click)="skipToResultContent()"
          class="sr-only sr-only-focusable"
          >Skip to Result Content</a
        >
        <app-validate-errors [messages]="data.messages"></app-validate-errors>
        <app-car-search></app-car-search>
        <div class="flex-row-container flex-row-container--right">
          <button
            i18n-title
            appButton="large-search"
            title="Start another search"
            (click)="reSearch()"
            i18n="@@carsSearch"
          >
            Search
          </button>
        </div>
      </app-search-toggle>
    </div>
  }
  <app-risk-alerts [countryCode]="dropoffCountry"></app-risk-alerts>
  <!-- end search -->
  <div class="flex-row-container switchrail_container">
    @if (searchService.searches[ServiceType.Hotel]?.cheapestPrice?.amount) {
      <button
        (click)="switchToHotel()"
        appButton="small"
        class="alternative-button"
        id="carresults-button-switchtoHotel"
      >
        <i class="ico-bed" aria-hidden="true"></i>
        <span i18n="@@flightHotelsFrom">Hotels from:</span>&nbsp;
        {{
          searchService.searches[ServiceType.Hotel].cheapestPrice.amount
            | currency: searchService.searches[ServiceType.Hotel].cheapestPrice.currencyCode
        }}
      </button>
    }
  </div>
  <!-- results -->
  @if (data.results && data.results.length === 0) {
    <app-no-results> </app-no-results>
  }
  @if (data.results.length > 0 && data.conversionRates) {
    <div id="car-list" class="car_search_results">
      @if (data.results.length > 1 && !defaultSortingPerformed) {
        {{ sortBy(sortOption) }}
      }
      <div class="flex-row-container flex-column-mobile">
        <div class="flex-column-container width-100">
          <div class="search_results_header">
            <div class="sort_results_actions results-width">
              <!-- Sort and Filtering Options -->
              <!-- Sort -->
              <div class="flex-column-container select-container">
                <span class="extras-label" i18n="@@carsSortBy">Sort by:</span>
                <button
                  aria-controls="sort-options"
                  [attr.aria-expanded]="showSortOptions"
                  class="toggle_sort"
                  (click)="toggleSortOptions()"
                  [ngClass]="{ toggle_sort_open: showSortOptions }"
                  aria-label="Sort by"
                  id="cars-sort-by"
                >
                  <span aria-hidden="true" id="sort-title">{{
                    sortOption | titlecase | translate
                  }}</span>
                </button>
                @if (showSortOptions) {
                  <ul
                    id="sort-options"
                    class="sort_by_options background-container-background top-230"
                  >
                    <li
                      id="cheapest-option"
                      (click)="sortBy(SortTypesCar.cheapest)"
                      (keydown.enter)="sortBy(SortTypesCar.cheapest)"
                      (keydown.esc)="toggleSortOptions()"
                      [ngClass]="{ active_option: sortOption === SortTypesCar.cheapest }"
                      tabindex="0"
                      (keydown.arrowdown)="moveArrowDown($event)"
                    >
                      <span i18n="@@carsCheapest">Cheapest</span>
                      <i class="ico-gbp" aria-hidden="true"></i>
                    </li>
                    <li
                      id="expensive-option"
                      (click)="sortBy(SortTypesCar.expensive)"
                      (keydown.enter)="sortBy(SortTypesCar.expensive)"
                      (keydown.esc)="toggleSortOptions()"
                      [ngClass]="{ active_option: sortOption === SortTypesCar.expensive }"
                      tabindex="0"
                      (keydown.arrowdown)="moveArrowDown($event)"
                    >
                      <span i18n="@@carsExpensive">Expensive</span>
                      <i class="ico-gbp" aria-hidden="true"></i>
                    </li>
                    <li
                      id="size-option"
                      (click)="sortBy(SortTypesCar.size)"
                      (keydown.enter)="sortBy(SortTypesCar.size)"
                      (keydown.esc)="toggleSortOptions()"
                      [ngClass]="{ active_option: sortOption === SortTypesCar.size }"
                      tabindex="0"
                      (keydown.arrowdown)="moveArrowDown($event)"
                      (keydown.arrowup)="moveArrowUp($event)"
                    >
                      <span i18n="@@carsSize">Size</span>
                      <i class="ico-size" aria-hidden="true"></i>
                    </li>
                    <li
                      id="chain-option"
                      (click)="sortBy(SortTypesCar.chain)"
                      (keydown.enter)="sortBy(SortTypesCar.chain)"
                      (keydown.esc)="toggleSortOptions()"
                      [ngClass]="{ active_option: sortOption === SortTypesCar.chain }"
                      tabindex="0"
                      (keydown.arrowup)="moveArrowUp($event)"
                      (keydown.tab)="toggleSortOptions()"
                    >
                      <span i18n="@@carsChain">Chain</span>
                      <i class="ico-car" aria-hidden="true"></i>
                    </li>
                    <li
                      id="preferred-option"
                      (click)="sortBy(SortTypesCar.preferred)"
                      (keydown.enter)="sortBy(SortTypesCar.preferred)"
                      (keydown.esc)="toggleSortOptions()"
                      [ngClass]="{ active_option: sortOption === SortTypesCar.preferred }"
                      tabindex="0"
                      (keydown.arrowup)="moveArrowUp($event)"
                      (keydown.tab)="toggleSortOptions()"
                    >
                      <span i18n="@@carsPref">Preferred</span>
                      <i class="ico-heart" aria-hidden="true"></i>
                    </li>
                    <li
                      id="lowest-emissions-option"
                      (click)="sortBy(SortTypesCar.lowestEmissions)"
                      (keydown.enter)="sortBy(SortTypesCar.lowestEmissions)"
                      (keydown.esc)="toggleSortOptions()"
                      [ngClass]="{ active_option: sortOption === SortTypesCar.lowestEmissions }"
                      tabindex="0"
                      (keydown.arrowdown)="moveArrowDown($event)"
                    >
                      <span i18n="@@Lowest Emissions">Lowest Emissions</span>
                      <img
                        class="flightDetails_greenerChoiceLogo"
                        src="https://images.sabscorp.com/images/logo/seedling.svg"
                        alt="Greener Choice"
                      />
                    </li>
                  </ul>
                }
              </div>
              <div class="flex-column-container">
                <span class="extras-label"> Filter: </span>
                <app-filters-slider>
                  <div class="filter_options_content" id="filters">
                    <div>
                      <div>
                        <div class="class_option_list filters-group">
                          <div class="flex-row-container">
                            <h3 i18n="@@carsClass">Class</h3>
                            @if (!showMoreClass && searchParams.carTypeCodes.length > 5) {
                              <span
                                class="car-filters-show-more"
                                (click)="showMoreClass = true; setFocus('toggle_class_button')"
                                (keydown.enter)="
                                  showMoreClass = true; setFocus('toggle_class_button')
                                "
                                (keydown.space)="
                                  showMoreClass = true; setFocus('toggle_class_button')
                                "
                                tabindex="0"
                                role="button"
                                id="toggle_class_button"
                                i18n-aria-label
                                i18n="@@carsSearchFiltersShowMore"
                                aria-label="Show more class filters"
                              >
                                Show more
                                <i class="ico-chevron-down" aria-hidden="true"></i>
                              </span>
                            }
                            @if (showMoreClass && searchParams.carTypeCodes.length > 5) {
                              <span
                                class="car-filters-show-more"
                                (click)="showMoreClass = false; setFocus('toggle_class_button')"
                                (keydown.enter)="
                                  showMoreClass = false; setFocus('toggle_class_button')
                                "
                                (keydown.space)="
                                  showMoreClass = false; setFocus('toggle_class_button')
                                "
                                tabindex="0"
                                role="button"
                                id="toggle_class_button"
                                i18n-aria-label
                                i18n="@@carsSearchFiltersShowLess"
                                aria-label="Show less class filters"
                              >
                                Show less
                                <i class="ico-chevron-up" aria-hidden="true"></i>
                              </span>
                            }
                          </div>
                          <ul class="search_filter_checkboxes">
                            @for (type of filters.types; track type; let i = $index) {
                              <mat-checkbox
                                [ngClass]="{ display_none: i > 4 && !showMoreClass }"
                                color="primary"
                                id="filter-checkbox-{{ type.display }}"
                                class="light-primary"
                                (keydown.esc)="closeFiltersOptions()"
                                value="{{ type.value }}"
                                (change)="filterClass(type.value)"
                                [checked]="filterClasses.indexOf(type.value) >= 0"
                                (keydown.enter)="filterClass(type)"
                              >
                                {{ type.display | splitCamelCase }}</mat-checkbox
                              >
                            }
                          </ul>
                        </div>
                        <div class="class_option_list filters-group">
                          <h3 i18n="@@carsTransmission">Transmission</h3>
                          <ul class="filters-checkbox-list">
                            <mat-checkbox
                              color="primary"
                              class="light-primary"
                              value="Automatic"
                              id="filter-checkbox-automatic"
                              (keydown.esc)="closeFiltersOptions()"
                              (change)="filterTransmission('auto')"
                              (keydown.enter)="filterTransmission('auto')"
                              [checked]="transmissionStringArray.indexOf('auto') >= 0"
                              i18n="@@carsAutomatic"
                            >
                              Automatic
                            </mat-checkbox>
                            <mat-checkbox
                              color="primary"
                              class="light-primary"
                              value="Manual"
                              id="filter-checkbox-manual"
                              (keydown.esc)="closeFiltersOptions()"
                              (change)="filterTransmission('manual')"
                              (keydown.enter)="filterTransmission('manual')"
                              [checked]="transmissionStringArray.indexOf('manual') >= 0"
                              i18n="@@carsManual"
                            >
                              Manual
                            </mat-checkbox>
                          </ul>
                        </div>
                        @if (filters.preference?.length) {
                          <div class="class_option_list filters-group">
                            <h3 i18n="@@negotiatedRates">Negotiated Rates</h3>
                            <ul class="search_filter_checkboxes">
                              @for (type of filters.preference; track type; let i = $index) {
                                <mat-checkbox
                                  color="primary"
                                  class="light-primary"
                                  id="filter-checkbox-{{ type.display }}"
                                  (keydown.esc)="closeFiltersOptions()"
                                  value="{{ type.value }}"
                                  (change)="filterPreference(type.value)"
                                  [checked]="filterPreferences.indexOf(type.value) >= 0"
                                  (keydown.enter)="filterPreference(type)"
                                >
                                  {{ type.display | splitCamelCase | translate }}</mat-checkbox
                                >
                              }
                            </ul>
                          </div>
                        }
                        <div class="class_option_list filters-group">
                          <h3 i18n="@@travelPolicy">Travel Policy</h3>
                          <ul class="search_filter_checkboxes">
                            @for (type of filters.travelPolicy; track type; let i = $index) {
                              <mat-checkbox
                                color="primary"
                                class="light-primary"
                                id="filter-checkbox-{{ type.display }}"
                                (keydown.esc)="closeFiltersOptions()"
                                value="{{ type.value }}"
                                (change)="filterTravelPolicy(type.value)"
                                [checked]="filterTravelPolicies.indexOf(type.value) >= 0"
                                (keydown.enter)="filterTravelPolicy(type)"
                              >
                                {{ type.display | translate }}</mat-checkbox
                              >
                            }
                          </ul>
                        </div>
                        <div class="class_option_list filters-group">
                          <h3 i18n="@@carsFuel">Fuel</h3>
                          <ul class="filters-checkbox-list">
                            @for (fuel of this.carFuelTypes; track fuel) {
                              <div>
                                <mat-checkbox
                                  color="primary"
                                  class="light-primary"
                                  [value]="fuel"
                                  id="filter-checkbox-{{ fuel }}"
                                  (keydown.esc)="closeFiltersOptions()"
                                  (change)="filterFuel(fuel)"
                                  (keydown.enter)="filterFuel(fuel)"
                                  [checked]="fuelStringArray.indexOf(fuel) >= 0"
                                >
                                  {{ fuel | translate }}
                                </mat-checkbox>
                              </div>
                            }
                          </ul>
                        </div>
                      </div>
                      <div>
                        <div class="class_option_list filters-group">
                          <h3 id="price_range" i18n="@@carsPriceRange">Price Range</h3>
                          <div class="slider_div">
                            <div class="custom-slider">
                              <ngx-slider
                                ariaLabelledBy="price_range"
                                [(value)]="filters.minPrice"
                                [(highValue)]="filters.maxPrice"
                                [options]="sliderOptions()"
                                (keydown.esc)="closeFiltersOptions()"
                                tabindex="-1"
                                aria-hidden="true"
                              ></ngx-slider>
                            </div>
                          </div>
                        </div>
                        <div class="class_option_list filters-group">
                          <h3 i18n="@@carsChainOption">Chain</h3>
                          <ul class="search_filter_checkboxes image_checks">
                            @for (chain of filters.companies; track chain; let i = $index) {
                              <li
                                (click)="filterChain(chain.display)"
                                (keydown.enter)="filterChain(chain.display)"
                                (keydown.esc)="closeFiltersOptions()"
                                role="button"
                                tabindex="0"
                                [ngClass]="{
                                  chosen_chain: filterChains.indexOf(chain.display) >= 0
                                }"
                                id="chain-filter-{{ chain.value }}"
                              >
                                <img
                                  [src]="chain.value"
                                  class="vendor"
                                  alt="Filter by car hire chain {{ chain.display }}"
                                />
                              </li>
                            }
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    appButton="small"
                    class="width-100 clear-button"
                    (click)="clearFilters()"
                    i18n="@@carsClear"
                    (keydown.esc)="closeFiltersOptions()"
                    aria-label="Clear filters"
                  >
                    Clear
                  </button>
                </app-filters-slider>
              </div>
            </div>
          </div>
          <app-filter-pills
            [filterClasses]="filterClasses"
            [filterTravelPolicies]="filterTravelPolicies"
            [filterPreferences]="filterPreferences"
            [filterChains]="filterChains"
            [filterMakeModels]="filterMakeModels"
            [transmissionStringArray]="transmissionStringArray"
            [fuelStringArray]="fuelStringArray"
            [serviceType]="ServiceType.Car"
            (carHireRemoveFilter)="carHireRemoveFilter($event)"
          ></app-filter-pills>
          <div class="search_results_items results-width">
            @for (result of data.results; track result; let i = $index) {
              @if (inFilters(result)) {
                <div class="car_item">
                  <!-- individual car item -->
                  <app-car-item
                    [result]="result"
                    [results]="data.results"
                    [index]="i"
                    [carDetailLoadingStates]="carDetailLoadingStates"
                    [preferredCurency]="preferredCurency"
                    [conversionRates]="data.conversionRates"
                  ></app-car-item>
                </div>
              }
            }
          </div>
        </div>
        @if (data.results.length <= 0) {
          <app-no-results></app-no-results>
        }
      </div>
    </div>
  }
  <!-- end results -->
}
<app-car-loading-screen [animated]="false"></app-car-loading-screen>
